/**
 * Development-only logger utility
 * Logs are only output in development mode to prevent sensitive data exposure in production
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  log: (...args: any[]): void => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  error: (...args: any[]): void => {
    if (isDevelopment) {
      console.error(...args);
    }
  },

  warn: (...args: any[]): void => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },

  info: (...args: any[]): void => {
    if (isDevelopment) {
      console.info(...args);
    }
  },

  debug: (...args: any[]): void => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },

  /**
   * Always logs errors even in production (for critical error tracking)
   * Use sparingly and ensure no sensitive data is logged
   */
  criticalError: (message: string, error?: unknown): void => {
    console.error('[CRITICAL]', message, error);
  }
};
